import styled from '@emotion/styled';

export const Wrapper = styled.div`
  padding-bottom: 0 !important;

  .badge {
    font-size: 12px;
    font-weight: 600;
  }

  .table-item {
    .title-wrapper {
      width: fit-content;
      position: relative;
    }

    .row-title {
      color: #72747b;
      font-weight: 500;
      font-size: 13px;
      margin: 0;
    }

    .row-comment {
      font-size: 11px;
      margin: 2px 0 0;
      color: #98a6ad;
    }

    i {
      display: none;
    }

    &:hover i {
      position: absolute;
      right: -20px;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      color: #98a6ad;
      cursor: pointer;
    }
  }
`;
